import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { GetAllFeatureFlagsResponseBody } from "services/onlineApplicationService";

export interface FeatureFlagsState {
    flags: GetAllFeatureFlagsResponseBody | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: FeatureFlagsState = {
    flags: null,
    isLoading: false,
    error: null,
};

export const featureFlagsSlice = createSlice({
    name: "featureFlags",
    initialState,
    reducers: {
        fetchFlagsStart: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        fetchFlagsSuccess: (state, action: PayloadAction<GetAllFeatureFlagsResponseBody>) => {
            state.flags = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        fetchFlagsFailure: (state, action: PayloadAction<string>) => {
            state.isLoading = false;
            state.error = action.payload;
            // Keep existing flags if we have them, otherwise set empty array
            if (!state.flags) {
                state.flags = [];
            }
        },
    },
});

export const { fetchFlagsStart, fetchFlagsSuccess, fetchFlagsFailure } = featureFlagsSlice.actions;

export default featureFlagsSlice.reducer;
